<p-dialog [style]="{ width: '50vw' }" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [header]="title()"
  [modal]="isModal" [draggable]="isDraggable" [resizable]="isResizable" [visible]="display()" (visibleChange)="display.set($event)" (onHide)="closeDialog()">
  <div class="content-container">
    <p>File must be in .csv format at least these columns, in any order:</p>
    <code>&nbsp;&nbsp;&nbsp;&nbsp;Email address, First name, Last name</code>
    <p-fileUpload #fileUploader accept=".csv" chooseLabel="Browse Files" [showUploadButton]="false"
      [showCancelButton]="false"></p-fileUpload>
  </div>
  <ng-template #footer>
    <div class="footer-container">
      <button pButton pRipple type="button" label="Cancel" (click)="closeDialog()"></button>
      <button pButton pRipple type="button" class="submitButton" label="Import File" [disabled]="!didUploadFile"
        (click)="onUpload()"></button>
    </div>
  </ng-template>
</p-dialog>